import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import { ssoLogin } from '@/utils/permission/router-permission-sso';
import basicRoutes from './routes/basic';
// import asyncRoutes from './routes/async';


NProgress.configure({
  showSpinner: false,
});

Vue.use(Router);

const routes = basicRoutes; // 不需要任何权限过滤的时候 =》 调整为 basicRoutes.concat(asyncRoutes)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  ssoLogin(router, to, from, next);
});

router.afterEach(() => {
  // 加载进度完成
  NProgress.done();
});

export default router;
